var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"table-head-button",on:{"click":() => _vm.$emit('click', _vm.type)}},[_c('span',{staticClass:"table-head-button__text"},[_vm._t("default")],2),_c('m-icon',{staticClass:"table-head-button__icon",class:{_active: _vm.active},attrs:{"icon":"arrow-up"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }